import { Market } from "@config/site/types";
import { monthDayRegex, dayMonthRegex, dateRegex } from "@lib/validators/regex/general";

export type NoYearDateFormat = "MM/DD" | "DD/MM";

export type DateOfBirthMarketConfig = {
    format: NoYearDateFormat;
    required: boolean;
};

const DATE_OF_BIRTH_CONFIG: Partial<Record<string, DateOfBirthMarketConfig>> = {
    [Market.JP]: { format: "MM/DD", required: true },
    [Market.KR]: { format: "MM/DD", required: false },
    [Market.US]: { format: "MM/DD", required: false },
    [Market.CA]: { format: "MM/DD", required: false },
    [Market.AU]: { format: "DD/MM", required: false },
    [Market.NZ]: { format: "DD/MM", required: false },
};

const DEFAULT_DATE_FORMAT = "DD/MM/YYYY";

const regexForFormat = (format: NoYearDateFormat): RegExp =>
    format === "MM/DD" ? monthDayRegex : dayMonthRegex;

export const getDateOfBirthMarketConfig = (country?: string): DateOfBirthMarketConfig | undefined =>
    DATE_OF_BIRTH_CONFIG[country?.toLowerCase() || ""];

export const getDateFormat = (country: string): string => {
    return getDateOfBirthMarketConfig(country)?.format ?? DEFAULT_DATE_FORMAT;
};

export const getDateRegex = (country?: string): RegExp => {
    const format = getDateOfBirthMarketConfig(country)?.format;
    return format ? regexForFormat(format) : dateRegex;
};

export const formatDateOfBirth = (date: string, country: string): string => {
    const format = getDateOfBirthMarketConfig(country)?.format;
    if (!format) return date;

    const [day, month] = date.split("/");
    return format === "MM/DD" ? `${month}/${day}` : `${day}/${month}`;
};
